










import { Component, Vue } from 'vue-property-decorator';
import { RouteName, TaftKeycloakRoles } from '@/utils/constants';
import HeaderTop from '@/components/base-layout/menu/HeaderTop.vue';
import SubHeaderMenu from '@/components/base-layout/menu/SubHeaderMenu.vue';
import { userManager } from '@/store/modules/auth.module';

@Component({
  components: { HeaderTop, SubHeaderMenu },
})
export default class MainViewMinistry extends Vue {
  async mounted() {
    const user = await userManager.getUser();
    const userRoles: string[] = (user?.profile?.roles as string[]) || [];
    if (this.$router.currentRoute.path === `/${RouteName.Ministry}`) {
      if (userRoles.includes(TaftKeycloakRoles.TAFT_MINISTRY_TASKS)
        && !userRoles.includes(TaftKeycloakRoles.TAFT_MINISTRY_REPORTS)) {
        this.$router.push(`/${RouteName.Ministry}/${RouteName.TaskList}`);
      } else {
        this.$router.push(`/${RouteName.Ministry}/${RouteName.Reports}`);
      }
    }
  }
}
